module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "color-skin",
    class: 'fa ' + _vm.faCircle + ' icon_check',
    on: {
      "click": _vm.toggleCircle
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9b36989a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/todoCheckbox.vue
// module id = 3936
// module chunks = 1